import styled from "styled-components";

export const HomeMain = styled.main`
  max-width: 350px;
  min-height: 80vh;
  margin: 0 auto;

  gap: 2rem;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: center;

  .btn {
    width: 100%;

    display: flex;
    align-items: stretch;
    flex-direction: column;
  }
`;
